import { render, staticRenderFns } from "./UpdateProductPriceModal.vue?vue&type=template&id=46fe1ac6&"
import script from "./UpdateProductPriceModal.vue?vue&type=script&lang=js&"
export * from "./UpdateProductPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports